import type { ConditionDetailType, ConditionOptionsType } from '../../types/condition';

const sortDetailCustomize = (a: ConditionDetailType | ConditionOptionsType, b: ConditionDetailType | ConditionOptionsType): number => {
  // https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
  const customer1A = a.customer1?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer1B = b.customer1?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer2A = a.customer2?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer2B = b.customer2?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer3A = a.customer3?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer3B = b.customer3?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const deliveryLocationA = a.deliveryLocation?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const deliveryLocationB = b.deliveryLocation?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const standardA = a.standard?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const standardB = b.standard?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const sizeA = !Number.isNaN(Number(a.sizeDisplay)) ? Number(a.sizeDisplay) : '';
  const sizeB = !Number.isNaN(Number(b.sizeDisplay)) ? Number(b.sizeDisplay) : '';
  if (customer1A < customer1B) {
    return -1;
  }
  if (customer1A > customer1B) {
    return 1;
  }
  if (customer2A < customer2B) {
    return -1;
  }
  if (customer2A > customer2B) {
    return 1;
  }
  if (customer3A < customer3B) {
    return -1;
  }
  if (customer3A > customer3B) {
    return 1;
  }
  if (deliveryLocationA < deliveryLocationB) {
    return -1;
  }
  if (deliveryLocationA > deliveryLocationB) {
    return 1;
  }
  if (standardA < standardB) {
    return -1;
  }
  if (standardA > standardB) {
    return 1;
  }
  if (sizeA < sizeB) {
    return -1;
  }
  if (sizeA > sizeB) {
    return 1;
  }
  // names must be equal
  return 0;
};

export default sortDetailCustomize;
